import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Une clases y resuelve conflictos de Tailwind (la última gana de verdad).
 *
 * Existía copiada literalmente en `Layout.tsx`, `Skeleton.tsx` y
 * `components/settings/SettingsUI.tsx`. Tres copias de cuatro líneas no son un
 * problema por su tamaño, sino porque son la señal de que no había dónde poner
 * lo compartido -- que es la causa de fondo del resto del sistema (UX_AUDIT H-15).
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export type { ClassValue };
